import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify, {
  iconfont: 'md',
})

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
});
